import React from "react";

const Input = ({ type, placeholder, handleChange, value, name, min, max }) => {
	return (
		<div>
			<input
				type={type}
				placeholder={placeholder}
				onChange={handleChange}
				value={value}
				name={name}
				min={min}
				max={max}
			/>
		</div>
	);
};

export default Input;
